import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="banner-img"
export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.containerTarget
    const mobileImg = new String(this.containerTarget.getAttribute("data-image-url-mobile"));
    const tabletImg = new String(this.containerTarget.getAttribute("data-image-url-tablet"));
    const desktopImg = new String(this.containerTarget.getAttribute("data-image-url-desktop"));

    if(window.innerWidth > 1024){                                            //desktop
      if(desktopImg.length > 0 ){
        this.containerTarget.style.backgroundImage = `url('${desktopImg}')`;
      } else if(tabletImg.length > 0) {
        this.containerTarget.style.backgroundImage = `url('${tabletImg}')`;
      } else {
        this.containerTarget.style.backgroundImage = `url('${mobileImg}')`;
      }
    } else if (window.innerWidth < 1025 && window.innerWidth > 501){         //tablet
      if(tabletImg.length > 0){
        this.containerTarget.style.backgroundImage = `url('${tabletImg}')`;
      } else if(mobileImg.length > 0) {
        this.containerTarget.style.backgroundImage = `url('${mobileImg}')`;
      } else {
        this.containerTarget.style.backgroundImage = `url('${desktopImg}')`;
      }
    } else {                                                                //mobile
      if(mobileImg.length > 0){
        this.containerTarget.style.backgroundImage = `url('${mobileImg}')`;
      } else if(tabletImg.length > 0) {
        this.containerTarget.style.backgroundImage = `url('${tabletImg}')`;
      } else {
        this.containerTarget.style.backgroundImage = `url('${desktopImg}')`;
      }
    }
      
  }
}